// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__RJzjV","text":"logo_text__3A1up","white":"logo_white__2IpiV","black":"logo_black__3eH7N"};